import { Controller } from '@hotwired/stimulus'
import { Offcanvas } from 'bootstrap'

// Wires a fleet matrix row to the summary offcanvas. Clicking the row sets the
// inner turbo-frame's `src` so the summary view is fetched lazily, and shows
// the offcanvas. Subsequent clicks just swap the src.
export default class extends Controller {
  static values = { url: String }

  open() {
    const frame = document.getElementById('guardian-fleet-summary')
    const panel = document.getElementById('guardian-fleet-offcanvas')
    if (!frame || !panel) return

    if (frame.src !== this.urlValue) {
      frame.src = this.urlValue
    }

    Offcanvas.getOrCreateInstance(panel).show()
  }
}
